module.exports = __webpack_public_path__ + "img/icon-customer-documents.0fe063d3.svg";